module.exports = __webpack_public_path__ + "img/bus-with-suitcases.b674b785.svg";